import * as Scrivito from "scrivito"

export const AppSidebarObjClass = Scrivito.provideObjClass("AppSidebar", {
  attributes: {
    menuLinks: ["widgetlist", { only: "LinkListWidget" }],
    menuLinksSecondary: ["widgetlist", { only: "LinkListWidget" }],
    menuLinksTertiary: ["widgetlist", { only: "LinkListWidget" }],
    userDetailsSlot: ["widgetlist", { only: "UserDetailsWidget" }]
  }
})
